"use strict";

exports.__esModule = true;
exports.TOKENS = exports.SIZE_OPTIONS = exports.BUTTON_STATES = void 0;
let SIZE_OPTIONS = exports.SIZE_OPTIONS = /*#__PURE__*/function (SIZE_OPTIONS) {
  SIZE_OPTIONS["SMALL"] = "small";
  SIZE_OPTIONS["NORMAL"] = "normal";
  SIZE_OPTIONS["LARGE"] = "large";
  return SIZE_OPTIONS;
}({});
let TOKENS = exports.TOKENS = /*#__PURE__*/function (TOKENS) {
  TOKENS["heightButton"] = "heightButton";
  TOKENS["fontSizeButton"] = "fontSizeButton";
  TOKENS["paddingButton"] = "paddingButton";
  TOKENS["paddingButtonWithIcons"] = "paddingButtonWithIcons";
  TOKENS["paddingButtonWithLeftIcon"] = "paddingButtonWithLeftIcon";
  TOKENS["paddingButtonWithRightIcon"] = "paddingButtonWithRightIcon";
  TOKENS["spinnerWidth"] = "spinnerWidth";
  TOKENS["spinnerHeight"] = "spinnerHeight";
  TOKENS["marginRightIcon"] = "marginRightIcon";
  return TOKENS;
}({});
let BUTTON_STATES = exports.BUTTON_STATES = /*#__PURE__*/function (BUTTON_STATES) {
  BUTTON_STATES["DEFAULT"] = "default";
  BUTTON_STATES["HOVER"] = "hover";
  BUTTON_STATES["ACTIVE"] = "active";
  BUTTON_STATES["FOCUS"] = "focus";
  return BUTTON_STATES;
}({});